import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, Eye, Trash2, Pencil } from "lucide-react";

export const UsersTab = ({ users, searchTerm, onSearch, onView, onDelete }) => (
  <Card className="bg-card border-border">
    <CardHeader>
      <div className="flex items-center justify-between">
        <CardTitle>User Management</CardTitle>
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
            className="pl-10 bg-transparent border-border"
          />
        </div>
      </div>
    </CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left p-3 text-muted-foreground text-sm">Name</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Email</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Badge</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Stars</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.user_id} className="border-b border-border hover:bg-muted/50">
                <td className="p-3">{user.name}</td>
                <td className="p-3 text-muted-foreground">{user.email}</td>
                <td className="p-3">
                  <span className="px-2 py-1 bg-primary/20 text-primary text-xs rounded">
                    {user.badge_tier}
                  </span>
                </td>
                <td className="p-3">{user.total_stars} ★</td>
                <td className="p-3">
                  <div className="flex gap-2">
                    <Button size="sm" variant="ghost" onClick={() => onView(user.user_id)}>
                      <Eye className="w-4 h-4" />
                    </Button>
                    <Button size="sm" variant="ghost" className="text-red-400 hover:text-red-300" onClick={() => onDelete(user.user_id)}>
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);

export const RestaurantsTab = ({ restaurants, onSearch, onEdit }) => (
  <Card className="bg-card border-border">
    <CardHeader>
      <div className="flex items-center justify-between">
        <CardTitle>Restaurant Management</CardTitle>
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search restaurants..."
            onChange={(e) => onSearch(e.target.value)}
            className="pl-10 bg-transparent border-border"
          />
        </div>
      </div>
    </CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left p-3 text-muted-foreground text-sm">Name</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Location</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Country</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Stars</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Cuisine</th>
              <th className="text-left p-3 text-muted-foreground text-sm">Actions</th>
            </tr>
          </thead>
          <tbody>
            {restaurants.map((rest) => (
              <tr key={rest.restaurant_id} className="border-b border-border hover:bg-muted/50">
                <td className="p-3">{rest.name}</td>
                <td className="p-3 text-muted-foreground">{rest.location}</td>
                <td className="p-3">{rest.country}</td>
                <td className="p-3 text-primary">{"★".repeat(rest.stars)}</td>
                <td className="p-3 text-muted-foreground">{rest.cuisine_type || "-"}</td>
                <td className="p-3">
                  <Button size="sm" variant="ghost" onClick={() => onEdit(rest)} data-testid={`edit-restaurant-btn-${rest.restaurant_id}`}>
                    <Pencil className="w-4 h-4" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
